
/* eslint-disable vue/no-v-html */
import SelectInput from '@marketplace/components/forms/inputs/select-input.vue'
import Loader from '@marketplace/components/shared/loaders/loader.vue'
import {
    OC_PLUS_SUBSCRIPTION_PLANS,
    SUBSCRIBE_MUTATION,
} from '@marketplace/graphql/ocplus.js'
import { trackClick } from '@marketplace/helpers/segment/index.js'

export default {
    name: 'BuyOcPlusPaymentMethod',

    components: {
        Loader,
        SelectInput,
    },
    props: {
        paymentFailed: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isLoading: true,
            isSubmitting: null,
            paymentMethod: null,
            currentStepInfo: {
                title: this.$t(
                    'headings.ocplus.buy_modal.payment.choose_payment_method'
                ),
                description: this.$t('headings.ocplus.buy_modal.payment.text'),
                imageUrl:
                    require('~assets/images/user-education/onboarding-modal-image-01.svg'),
            },
            plan: null,
            paymentMethods: [],
            noPaymentSelected: false,
        }
    },
    async fetch() {
        await this.$apollo
            .query({
                fetchPolicy: 'cache-first',
                query: OC_PLUS_SUBSCRIPTION_PLANS,
            })
            .then(({ data }) => {
                this.plan = data?.viewer?.orderchampPlusPlans?.find(
                    (plan) => plan.slug === 'orderchamp_plus_subscription_base'
                )

                if (this.$route.query.plan) {
                    this.plan = data?.viewer?.orderchampPlusPlans?.find(
                        (plan) => plan.slug === this.$route.query.plan
                    )
                }

                this.paymentMethods =
                    data?.viewer?.orderchampPlusPaymentMethods || []
            })
            .finally(() => {
                this.isLoading = false
            })
            .catch((error) => {
                this.$sentry.captureException(error)
            })
    },

    computed: {
        amountToBePaid() {
            // Hydration phase
            if (!this.plan?.amount) return this.$n(0, 'currency')

            const amount =
                Number(this.plan?.discountedAmount) || Number(this.plan?.amount)

            const taxAmount = Number(this.plan?.taxAmount) || 0

            const total = (amount + taxAmount).toFixed(2)

            return this.$n(total, 'currency')
        },
        summary() {
            return [
                {
                    label: this.$t('labels.ds.price'),
                    value: this.$t('label.ds.price_per_renewal', {
                        total: this.$n(this.plan?.amount, 'currency'),
                        period: this.$t('labels.ds.month'),
                    }),
                    hasDiscount: this.planDiscount,
                },
                {
                    label: this.$t('labels.tax'),
                    value: `${this.$n(
                        this.plan?.taxAmount,
                        'currency'
                    )} (${this.$n(this.plan?.taxPercentage / 100, 'percent')})`,
                },
                {
                    label: this.$t('labels.ds.subtotal'),
                    value: this.amountToBePaid,
                },
                {
                    label: this.$t('labels.ds.payment_frequency'),
                    value: this.$t('labels.ds.monthly'),
                },
            ]
        },
        planDiscount() {
            return this.plan?.availableCoupon
                ? this.plan?.availableCoupon?.amount ||
                      this.plan?.availableCoupon?.percentage
                : false
        },
        planDiscountInfo() {
            if (!this.planDiscount) return null

            const couponInfo = this.plan.availableCoupon

            return {
                discountValueWithSymbol: couponInfo.amount
                    ? this.$n(couponInfo.amount, 'currency')
                    : this.$n(couponInfo.percentage / 100, 'percent'),
                discountDuration: couponInfo.times,
            }
        },

        availablePaymentMethods() {
            return this.paymentMethods.filter((item) => {
                if (item.id !== 'mollie-applepay') {
                    return true
                }

                return (
                    window.ApplePaySession &&
                    window.ApplePaySession.canMakePayments()
                )
            })
        },

        mappedPaymentMethodsForSelectBox() {
            return this.availablePaymentMethods.map((method) => ({
                value: method.id,
                label: method.name,
            }))
        },
    },

    methods: {
        handleNextClick(paymentMethod) {
            if (!paymentMethod) {
                this.noPaymentSelected = true
                return
            }

            this.createRequest(paymentMethod)
            localStorage.setItem('ocShowPlusPaymentModal', 'true')
            trackClick('OC Plus proceed to payment')
        },
        createRequest(method) {
            this.isSubmitting = true

            this.$apollo
                .mutate({
                    mutation: SUBSCRIBE_MUTATION,
                    variables: {
                        input: {
                            plan: this.plan.slug,
                            method: method.toString().replace(/mollie-/, ''),
                        },
                    },
                })
                .then(({ data }) => {
                    if (data.orderchampPlusSubscribe?.url) {
                        window.location = data.orderchampPlusSubscribe.url
                    }
                })
                .catch((error) => {
                    this.$sentry.captureException(error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        },
    },
}
